import React, { useState, useEffect } from 'react';
import { generateId } from '@appblocks/utils';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';

function ReadMoreComponent(props) {
    const [open, setOpen] = useState(false);
    const id = generateId();

    return (
        <>
            {props.initialText}
            <Collapse in={open}>
                <div id={`read-more-${id}`}>
                    {props.readMoreText}
                </div>
            </Collapse>
            {props.readMoreText && (
                <Button
                    variant="link"
                    className="ps-0"
                    onClick={() => setOpen(!open)}
                    aria-controls={`read-more-${id}`}
                    aria-expanded={open}
                >
                    {!open ? 'Show More' : 'Show Less'}
                </Button>
            )}
        </>
    );
}

export default ReadMoreComponent;
